function pagination(isInfinite = true, done, isMasonry = false) {
    const feed = document.querySelector('[data-post-feed]');
    const target = document.querySelector('[data-feed-pagination]');
    const status = document.querySelector('[data-feed-status]');
    const retry = document.querySelector('[data-feed-retry]');
    if (!feed || !target || feed.dataset.paginationReady) return;
    if (!('IntersectionObserver' in window)) return;
    feed.dataset.paginationReady = 'true';
    target.dataset.enhanced = 'true';
    const nextLink = document.querySelector('link[rel="next"]');
    let next = nextLink?.href || '';
    let loading = false;
    let failed = false;
    const visited = new Set();
    const known = new Set(Array.from(feed.querySelectorAll('.gh-card-link'), (a) => a.href));
    const showStatus = (message) => {
        if (status) { status.textContent = message; status.hidden = !message; }
    };
    const load = async () => {
        if (loading || !next || failed) return;
        loading = true;
        showStatus('글을 불러오는 중입니다…');
        try {
            const url = new URL(next, location.href);
            if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid next page');
            const response = await fetch(url.href, {credentials: 'same-origin', signal: AbortSignal.timeout(15000)});
            if (!response.ok) throw new Error('Page request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const source = doc.querySelector('[data-post-feed]');
            if (!source) throw new Error('Missing post feed');
            const fragment = document.createDocumentFragment();
            const added = [];
            source.querySelectorAll(':scope > .gh-card').forEach((card) => {
                const link = card.querySelector('.gh-card-link');
                if (!link) return;
                const href = new URL(link.getAttribute('href'), url).href;
                if (known.has(href)) return;
                known.add(href);
                const clone = document.importNode(card, true);
                if (isMasonry) clone.style.visibility = 'hidden';
                fragment.append(clone);
                added.push(clone);
            });
            feed.append(fragment);
            visited.add(url.href);
            const following = doc.querySelector('link[rel="next"]')?.getAttribute('href');
            next = following ? new URL(following, url).href : '';
            if (nextLink) { if (next) nextLink.href = next; else nextLink.remove(); }
            if (done) done(added, load);
            showStatus(next ? '' : '모든 글을 확인하셨습니다.');
            if (!next) observer.disconnect();
        } catch (_) {
            failed = true;
            showStatus('글을 불러오지 못했습니다. 다시 시도해 주세요.');
            if (retry) retry.hidden = false;
        } finally {
            loading = false;
        }
    };
    const fillViewport = async () => {
        while (next && !failed && !loading && target.getBoundingClientRect().top < window.innerHeight + 500) {
            await load();
        }
    };
    const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) void fillViewport();
    }, {rootMargin: '500px 0px'});
    if (retry) retry.addEventListener('click', async () => {
        failed = false;
        retry.hidden = true;
        await load();
        if (isInfinite) void fillViewport();
    });
    if (next && isInfinite) observer.observe(target);
    else if (next && retry) { retry.hidden = false; retry.textContent = '더 불러오기'; }
}
